module.exports = __webpack_public_path__ + "static/img/about3.ab185ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about3.png
// module id = TqU4
// module chunks = 0